module.exports = __webpack_public_path__ + "img/eye-in-welcome.eaa8dd86.jpg";